import MuiPaper from '@mui/material/Paper';
import React from 'react';
import { useStyles } from './styles';

type Props = {
    children: React.ReactNode;
    className?: string;
};

const Paper = ({ children, className }: Props) => {
    const classes = useStyles();

    return <MuiPaper className={`${classes.root} ${className}`}>{children}</MuiPaper>;
};

export default Paper;
